// SHELF-FLASH-2 — what the menu shows while it does not yet know what this
// account hides.
//
// THE ALTERNATIVE WAS THE BUG. Before this, "we have not read the hidden rows
// yet" rendered the FULL menu, so a blank account showed all seven sections —
// Team included — and then five of them vanished when the read landed. A
// skeleton is not decoration here; it is the only honest thing to draw when
// the answer is unknown.
//
// DELIBERATELY NOT A SPINNER. A spinner says "something is happening"; these
// bars say "a menu is coming, and it will be about this shape", which is what
// somebody staring at a sidebar needs. And they do not move: an animation that
// runs for three round trips draws the eye to the one part of the screen that
// has nothing to say.

/** One placeholder row, sized like a section. */
function Row({ width }: { width: string }) {
  return (
    <div className="flex items-center gap-2 px-3 py-2">
      <div className="h-4 w-4 rounded bg-muted shrink-0" />
      <div className="h-3 rounded bg-muted" style={{ width }} />
    </div>
  )
}

/**
 * The widths vary so it reads as a menu rather than a loading bar, and the
 * count is deliberately SMALL — four, not the ten a full tree would have.
 * Drawing ten and settling to two is the same flicker in a paler colour.
 */
const WIDTHS = ['58%', '44%', '66%', '38%']

export function NavSkeleton({ label = 'Loading your menu' }: { label?: string }) {
  return (
    <div aria-busy="true" aria-label={label} role="status" data-testid="nav-skeleton">
      <span className="sr-only">{label}</span>
      {WIDTHS.map((w, i) => (
        <Row key={i} width={w} />
      ))}
    </div>
  )
}
